exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-title {\r\n  padding:10px;\r\n}\r\n\r\na:focus , a , a:hover{\r\n  text-decoration: none;\r\n  color:white;\r\n}\r\n\r\n.panel-heading {\r\n  position: relative;\r\n  background:#931246;\r\n  color:white;\r\n}\r\n\r\n\r\n.panel-heading[data-toggle=\"collapse\"]::after {\r\n  font-family: 'Glyphicons Halflings';\r\n  content: \"\\E072\"; /* \"play\" icon */\r\n  position: absolute;\r\n  color: white;\r\n  font-size: 18px;\r\n  line-height: 22px;\r\n  right: 20px;\r\n  top: calc(50% - 10px);\r\n\r\n  /* rotate \"play\" icon from > (right arrow) to down arrow */\r\n  transform:         rotate(-90deg);\r\n}\r\n.panel-heading[data-toggle=\"collapse\"].collapsed:after {\r\n  /* rotate \"play\" icon from > (right arrow) to ^ (up arrow) */\r\n  transform:         rotate(90deg);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/faq/faq.component.css
// module id = ../../../../../src/app/faq/faq.component.css
// module chunks = 2